import { DemandeLabels } from "./DemandeLabels";

export const Dictionnaries = {
    DemandeLabels
}